import {
  Button as Button2,
  DataGrid,
  DropDownBox,
  Popup,
  SelectBox,
} from "devextreme-react";
import {
  Button,
  Column,
  Editing,
  FilterRow,
  Form,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Item,
  LoadPanel,
  Lookup,
  Paging,
  PatternRule,
  Scrolling,
  SearchPanel,
  Selection,
  StateStoring,
  Texts,
  Toolbar,
} from "devextreme-react/data-grid";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import axios from "axios";
import { Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import { ToolbarItem } from "devextreme-react/popup";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import jsPDF from "jspdf";
import { notifyMsg } from "../common/notify";
import { CAT, CAT_FILTER, CAT_OBJ, TYPE_INTERNAL } from "./data";
import SignatureItem from "./SignatureItem";
import TrainingAttendanceList from "./TrainingAttendanceListItem";

import { exportDataGrid as exportDataGridToPDF } from "devextreme/pdf_exporter";
import { malgun } from "../common/malgun";
import { hBeccoCRO } from "./hBeccoCRO";

export default function TrainingPlan(props) {
  const userInfo = useSelector((state) => state.userInfo);

  const [dataSource, setDataSource] = useState(null);
  const [employeeDataSource, setEmployeeDataSource] = useState(null);
  const [signaturePopupVisible, setSignaturePopupVisible] = useState(false);
  const [tpData, setTpData] = useState({});
  const [signatureTraineeDataSource, setSignatureTraineeDataSource] =
    useState(null);

  const [noSig, setNoSig] = useState(false);
  const [type, setType] = useState(null);
  const [myDiv, setMyDiv] = useState(false);
  const [filterNoSig, setFilterNoSig] = useState(false);

  const trainerRef = useRef(null);
  const signatureTraineeGridRef = useRef(null);
  const formATReasonRef = useRef(null);
  const trDataGridRef = useRef(null);

  const { tralGridRef } = props;

  // TrainingProgramItem
  const trRef = useRef(null);
  const [trValue, setTrValue] = useState(null);
  const [isGridBoxOpened, setIsGridBoxOpened] = useState(false);
  const [trDataSource, setTrDataSource] = useState(null);

  // Trainee
  // const treeViewRef = useRef(null);
  // const traineeRef = useRef(null);
  // const [traineeValue, setTraineeValue] = useState(null);
  const traineeRef = useRef(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BECCO_API_URL}/api/employee?tenure=1`)
      .then((result) => {
        // setEmployeeDataSource(result.data);

        setEmployeeDataSource(
          new DataSource({
            store: {
              type: "array",
              data: result.data,
              key: "employeeNo",
            },
            group: "div",
          })
        );
      });

    setDataSource(
      new CustomStore({
        key: "tpId",
        load: async () => {
          try {
            const result = await axios.get(
              `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tp`
            );

            return result.data;
          } catch (error) {
            console.log(error);
          }
        },
        insert: async (values) => {
          values = {
            ...values,
            trainer: trainerRef.current.instance.option("value"),
            employeeNo: userInfo.employeeNo,
          };

          if (values.type != 9) {
            values = {
              ...values,
              // trainer: trainerRef.current.instance.option("value"),
              trId: trRef.current.instance.option("value")[0],
              // trainee: traineeRef.current.instance
              //   .option("value")
              //   .filter((trainee) => trainee.length == 8),
              // employeeNo: userInfo.employeeNo,
            };
            // setTrValue(null);
          }

          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tp`,
            values
          );
        },
        update: async (key, values) => {
          // setATReasonPopupVisible(true);

          let gridInstance = tralGridRef.current.instance;
          let editRowKey = gridInstance.option("editing.editRowKey");
          let index = gridInstance.getRowIndexByKey(editRowKey);
          index = index === -1 ? 0 : index;

          values = {
            ...values,
            employeeNo: userInfo.employeeNo,
            type: gridInstance.cellValue(index, "type"),
          };

          if (values.type != "9") {
            values = {
              ...values,
              trId: trRef.current.instance.option("value")[0],
            };
          }

          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tp/${key}`,
            {
              ...values,
            }
          );

          // if (values.type != "9") {
          //   await axios.put(
          //     `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tp/${key}`,
          //     {
          //       // tpId: tpId,
          //       ...values,
          //       trId: trRef.current.instance.option("value")[0],
          //       // trainee: traineeRef.current.instance
          //       //   .option("value")
          //       //   .filter((trainee) => trainee.length == 8),
          //       // employeeNo: userInfo.employeeNo,
          //     }
          //   );
          // }
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tp/${key}`,
            {
              data: {
                employeeNo: userInfo.employeeNo,
              },
            }
          );
        },
      })
    );
  }, []);

  useEffect(() => {
    if (type) {
      setTrDataSource(
        new CustomStore({
          loadMode: "raw",
          key: "trId",
          load: async () => {
            try {
              const result = await axios.get(
                `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tr?type=${type}&provider=1`
              );
              return result.data;
            } catch (error) {
              return console.log(error);
            }
          },
        })
      );
    }
  }, [type]);

  // TrainingProgramItem
  const displayExpr = (item) => {
    // return `[${CAT_OBJ[item.cat]} | ${TYPE_OBJ[item.type]}] ${item.title} (${
    //   item.time
    // } Hours)`;

    if (item) {
      return `[${CAT_OBJ[item.cat]}] ${item.title} (${item.time} Hours)`;
    } else {
      return null;
    }
  };

  // TrainingProgramItem
  const onOptionChanged = (e) => {
    if (e.name === "opened") {
      setIsGridBoxOpened(e.value);
    }
  };

  // TrainingProgramItem
  const onValueChanged = (e) => {
    setTrValue(e.value);

    if (trRef.current && trRef.current.instance.option("value") == null) {
      trRef.current.instance.option("validationStatus", "invalid");
    }
  };

  // TrainingProgramItem
  const onSelectionChanged = (e) => {
    setTrValue(e.selectedRowKeys);
    setIsGridBoxOpened(false);
  };

  // TrainingProgramItem
  const contentRender = () => {
    return (
      <DataGrid
        ref={trDataGridRef}
        keyExpr={"trId"}
        dataSource={trDataSource}
        hoverStateEnabled={true}
        selectedRowKeys={trValue}
        onSelectionChanged={onSelectionChanged}
        height="100%"
        showBorders={true}
        showColumnLines={true}
      >
        <Selection mode="single" />
        <Scrolling mode="virtual" showScrollbar="always" />
        <Paging enabled={true} pageSize={10} />

        <Grouping autoExpandAll={false} expandMode={"rowClick"} />
        <GroupPanel visible={true} />

        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <SearchPanel visible={true} placeholder={"Search..."} />

        {/* <Column dataField={"id"} caption="id" /> */}
        <Column dataField={"cat"} caption="Category" width={100} groupIndex={1}>
          <Lookup dataSource={CAT} displayExpr="name" valueExpr="id" />
          <HeaderFilter dataSource={CAT_FILTER} />
        </Column>
        {/* <Column dataField={"type"} caption="Type" width={120}>
          <Lookup
            dataSource={TYPE_INTERNAL}
            displayExpr="name"
            valueExpr="id"
          />
        </Column> */}
        <Column dataField={"title"} cap tion="Title" />
        <Column dataField={"time"} caption="Time (Hours)" width={150} />
      </DataGrid>
    );
  };

  const itemRender = ({ employeeNo, name }) => {
    return (
      <div>
        {name} ({employeeNo})
      </div>
    );
  };

  const displayExprEmployee = (item) => {
    if (item) {
      return `${item.name} (${item.employeeNo})`;
    } else {
      return null;
    }
  };

  const onSaving = React.useCallback(async (e) => {
    if (trRef.current) {
      if (trRef.current.instance.option("value") == null) {
        trRef.current.instance.option("validationStatus", "invalid");

        e.cancel = true;
      }

      // Training Program Update
      if (e.changes.length == 0) {
        const tpId = tralGridRef.current.instance.option("editing.editRowKey");

        await axios.put(
          `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tp/${tpId}`,
          {
            // tpId: tpId,
            trId: trRef.current.instance.option("value")[0],
            // trainee: traineeRef.current.instance
            //   .option("value")
            //   .filter((trainee) => trainee.length == 8),
            employeeNo: userInfo.employeeNo,
          }
        );

        tralGridRef.current.instance.refresh();
      }
    }
  }, []);

  const onSaved = React.useCallback((e) => {
    setTrValue(null);
    // setTraineeValue(null);
  }, []);

  const onEditCanceled = React.useCallback((e) => {
    setTrValue(null);

    // setTraineeValue(null);
  }, []);

  const cellRenderTrainee = (data) => {
    const { traineeName } = data.data;

    return <div>{traineeName}</div>;
  };

  const cellRenderTime = (data) => {
    const { time } = data.data;

    return <div>{time}h</div>;
  };

  const onEditingStart = (e) => {
    setTrValue(Array.of(e.data.trId));

    if (typeof e.data.trainee == "string") {
      e.data.trainee = e.data.trainee.split(",");
    }

    setType(e.data.type);
  };

  const checkDisabled = (e) => {
    const { trainer, trainerSig } = e.row.data;

    if (
      userInfo.employeeNo == e.row.data.trainer ||
      e.row.data.trainee.includes(userInfo.employeeNo) ||
      userInfo.jd == "RV"
    ) {
      return false;
    } else {
      return true;
    }
  };

  const editNDeleteDisabled = (e) => {
    const { trainer, trainerSig, trainee, traineeSig } = e.row.data;

    const traineeLength =
      typeof trainee === "string" ? trainee.split(",").length : trainee.length;

    if (trainerSig) {
      return true;
    } else if (traineeLength > traineeSig) {
      // 최소 1명 이상의 Trainee 서명 진행 시 데이터 수정 불가
      return true;
    } else if (userInfo.employeeNo == trainer) {
      return false;
    } else {
      return true;
    }
  };

  const cellRenderTrainerSig = (data) => {
    const { tpId, trainerSig, trainer } = data.data;

    return (
      <SignatureItem
        gridRef={tralGridRef}
        tpId={tpId}
        isTrainer={true}
        sig={trainerSig}
        sigEmployeeNo={trainer}
      />
    );
  };

  const cellRenderTraineeSig = (data) => {
    const { tpId, sig, trainee } = data.data;

    return (
      <SignatureItem
        gridRef={tralGridRef}
        tpId={tpId}
        isTrainer={false}
        sig={sig}
        sigEmployeeNo={trainee}
        setTrainingAttendanceListSignaturePopupVisible={
          setSignaturePopupVisible
        }
      />
    );
  };

  const onClick = (e) => {
    if (
      Date.parse(e.row.data.date) + e.row.data.time * 60 * 60 * 1000 >
      Date.now()
    ) {
      notifyMsg("교육 시간이 종료되지 않았습니다.", "warning");
    } else {
      setSignaturePopupVisible(true);

      setTpData(e.row.data);

      setSignatureTraineeDataSource(
        new CustomStore({
          key: "no",
          load: async () => {
            try {
              const result = await axios.get(
                `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/tp/trainee/${e.row.data.tpId}`
              );

              setNoSig(
                result.data.find((trainee) => trainee.sig == null)
                  ? true
                  : false
              );

              return result.data;
            } catch (error) {
              console.log(error);
            }
          },
        })
      );
    }
  };

  const onHiding = () => {
    setSignaturePopupVisible(false);
  };

  const cellRenderTraineeOnSignature = (data) => {
    const { trainee, traineeName } = data.data;

    return (
      <div>
        {traineeName} ({trainee})
      </div>
    );
  };

  const onClickRefresh = () => {
    tralGridRef.current.instance.getDataSource().reload();
  };

  const titleRender = () => {
    return <p>Training Attending List</p>;
  };

  const exportPDF = () => {
    const doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: [297, 210],
      encryption: {
        userPermissions: ["print"],
      },
      compressPdf: true,
    });

    doc.addFileToVFS("malgun.ttf", malgun);
    doc.addFont("malgun.ttf", "malgun", "normal");
    doc.setFont("malgun");

    doc.setFontSize(5);

    const dataGrid = signatureTraineeGridRef.current.instance;

    exportDataGridToPDF({
      jsPDFDocument: doc,
      component: dataGrid,
      // autoTableOptions: {
      //   styles: {
      //     font: "malgun",
      //     overflow: "linebreak",
      //     cellWidth: "wrap",
      //     fontSize: 7,
      //     valign: "middle",
      //     halign: "center",
      //     overflowColumns: "linebreak",
      //   },
      //   margin: {
      //     left: 7,
      //     right: 7,
      //     top: 30,
      //   },
      //   startY: 70,
      // },
      margin: {
        left: 7,
        right: 7,
        top: 30,
      },
      // startY: 70,
      topLeft: { x: 1, y: 35 },

      loadPanel: {
        enabled: true,
        // shading: true,
        // shadingColor: "#f5f5f5",
      },
    }).then(() => {
      doc.setPage(1);

      doc.addImage(`data:image/png;base64,${hBeccoCRO}`, "png", 7, 7, 20, 7);

      const header = `Training Attending List`;
      const pageWidth = doc.internal.pageSize.getWidth();
      doc.setFontSize(15);
      const headerWidth = doc.getTextDimensions(header).w;
      doc.text(header, (pageWidth - headerWidth) / 2, 20);

      const body = [
        ["Training Program", tpData.title],
        ["Training Date & Time", `${tpData.date} (${tpData.time}h)`],
        ["Trainer", `${tpData.trainerName} (Sig: ${tpData.trainerSig})`],
        ["Location", tpData.loc],
      ];

      doc.autoTable({
        startY: 30,
        margin: {
          left: 7,
          right: 7,
        },
        styles: { font: "malgun", fontStyle: "normal" },
        body: body,
      });

      // doc.setProperties({
      //   title: "Training Attending List",
      //   author: "BeccoCRO Inc.",
      //   creator: "BeccoCRO Inc.",
      // });

      const date = new Date(tpData.date);

      doc.save(
        `Training Attending List_${tpData.title}_${date.getFullYear()}${String(
          date.getMonth() + 1
        ).padStart(2, "0")}${String(date.getDate()).padStart(2, "0")}.pdf`
      );
    });
  };

  const customizeItem = (item) => {
    if (item) {
      if (item.dataField == "trId") {
        const type = getTypeValue();

        if (type) {
          if (type != "9") {
            item.visible = true;
          }
        }
      } else if (
        item.dataField == "cat" ||
        item.dataField == "title" ||
        item.dataField == "time"
      ) {
        const type = getTypeValue();

        if (type) {
          if (type == "9") {
            item.visible = true;
          }
        }
      }
    }
  };

  const getTypeValue = () => {
    let gridInstance = tralGridRef.current.instance;
    let editRowKey = gridInstance.option("editing.editRowKey");
    let index = gridInstance.getRowIndexByKey(editRowKey);

    index = index === -1 ? 0 : index;

    return gridInstance.cellValue(index, "type");
  };

  const setCellValue = (newData, value) => {
    newData.type = value;

    setType(value);
  };

  const onClickMyDiv = () => {
    if (!myDiv) {
      if (tralGridRef.current) {
        tralGridRef.current.instance.filter([
          ["trainerDiv", "=", userInfo.div],
          "OR",
          ["traineeDiv", "contains", userInfo.div],
        ]);
      }
    } else {
      tralGridRef.current.instance.clearFilter();
    }

    setMyDiv(!myDiv);
  };

  const onClickFilterNoSig = () => {
    if (!filterNoSig) {
      if (tralGridRef.current) {
        tralGridRef.current.instance.filter(["trainerSig", "=", null], "OR", [
          "traineeSig",
          ">",
          0,
        ]);
      }
    } else {
      tralGridRef.current.instance.clearFilter();
    }

    setFilterNoSig(!filterNoSig);
  };

  function calculateFilterExpression(
    filterValue,
    selectedFilterOperation,
    target
  ) {
    if (selectedFilterOperation == "=") {
      const date2 = new Date(filterValue);

      date2.setDate(date2.getDate() + 1);

      const filterExpression = [
        [this.dataField, ">=", new Date(filterValue)],
        "and",
        [this.dataField, "<=", date2],
      ];

      return filterExpression;
    }

    if (selectedFilterOperation === "between") {
      const date2 = new Date(filterValue[1]);

      date2.setDate(date2.getDate() + 1);

      const filterExpression = [
        [this.dataField, ">=", new Date(filterValue[0])],
        "and",
        [this.dataField, "<=", date2],
      ];

      return filterExpression;
    }

    if (!this.defaultCalculateFilterExpression)
      return [this.dataField, "contains", new Date(filterValue)];

    return this.defaultCalculateFilterExpression.apply(this, arguments);
  }

  return (
    <React.Fragment>
      {userInfo.employeeNo && (
        <DataGrid
          id="tralGrid"
          ref={tralGridRef}
          dataSource={dataSource}
          keyExpr="tpId"
          rowAlternationEnabled={true}
          showBorders={true}
          showColumnLines={true}
          allowColumnResizing={true}
          columnAutoWidth={true}
          width={"100%"}
          wordWrapEnabled={true}
          allowColumnReordering={true}
          height={"100%"}
          style={{
            maxHeight: "calc(100vh - 145px)",
          }}
          hoverStateEnabled={true}
          onSaving={onSaving}
          onSaved={onSaved}
          onEditCanceled={onEditCanceled}
          onEditingStart={onEditingStart}
        >
          <LoadPanel enabled={true} />
          <FilterRow visible={true} />
          <HeaderFilter visible={true} />
          {/* <Export enabled={true} /> */}
          <GroupPanel visible={true} />
          <SearchPanel visible={true} />
          <Scrolling mode={"virtual"} showScrollbar="always" />
          {/* <StateStoring
            enabled={true}
            type="localStorage"
            storageKey={"Training.TrainingPlan"}
          /> */}
          <Editing
            mode={"form"}
            allowUpdating={true}
            allowAdding={true}
            allowDeleting={true}
            useIcons={true}
          >
            <Texts
              confirmDeleteMessage={
                "Are you sure you want to delete this training plan?"
              }
              confirmDeleteTitle="Delete the Training Plan"
            />
            <Form
              labelMode={"outside"}
              showColonAfterLabel={false}
              labelLocation={"top"}
              minColWidth={300}
              colCount={2}
              colCountByScreen={{ sm: 2, md: 4 }}
              screenByWidth={(width) => {
                return width < 720 ? "sm" : "md";
              }}
              validationGroup="trainingAttendanceList"
              customizeItem={customizeItem}
            >
              <SimpleItem
                dataField={"type"}
                editorType="dxSelectBox"
                editorOptions={{
                  dataSource: TYPE_INTERNAL,
                  valueExpr: "id",
                  showClearButton: true,
                  displayExpr: "name",
                }}
              >
                <Label text={"Training Type"} />
                <RequiredRule message={"* Training Type을 입력해주세요."} />
              </SimpleItem>
              <SimpleItem
                dataField={"cat"}
                visible={false}
                editorType="dxSelectBox"
                editorOptions={{
                  dataSource: CAT,
                  valueExpr: "id",
                  showClearButton: true,
                  displayExpr: "name",
                }}
              >
                <Label text="Category" />
                <RequiredRule message={"* Category를 입력해주세요."} />
              </SimpleItem>
              <SimpleItem
                dataField={"title"}
                visible={false}
                editorType="dxTextBox"
                editorOptions={{
                  showClearButton: true,
                }}
              >
                <RequiredRule message={"* Title을 입력해주세요."} />
              </SimpleItem>
              <SimpleItem
                dataField={"time"}
                visible={false}
                editorType="dxNumberBox"
                editorOptions={{
                  showClearButton: true,
                }}
              >
                <Label text={"Duration (Hours)"} />
                <RequiredRule message={"* Duration을 입력해주세요."} />
                <PatternRule
                  message="* Duration은 최대 99시간까지 가능합니다. (소수점 2자리)"
                  pattern={/^[0-9]{0,2}(\.[0-9]{0,2})?$/}
                />
              </SimpleItem>
              <SimpleItem colSpan={2} dataField="trId" visible={false}>
                <Label text={"Training Program"} />
                <DropDownBox
                  // dataField={"trId"}
                  ref={trRef}
                  name="trId"
                  value={trValue}
                  opened={isGridBoxOpened}
                  valueExpr="trId"
                  deferRendering={false}
                  displayExpr={displayExpr}
                  placeholder="Select a value..."
                  showClearButton={true}
                  dataSource={trDataSource}
                  onValueChanged={onValueChanged}
                  onOptionChanged={onOptionChanged}
                  contentRender={contentRender}
                  validationGroup="trainingAttendanceList"
                  // validationStatus="invalid"
                ></DropDownBox>
                <RequiredRule message={"* Training Program을 선택해주세요."} />
              </SimpleItem>
              <SimpleItem
                dataField={"date"}
                editorType="dxDateBox"
                editorOptions={{
                  type: "datetime",
                  displayFormat: "yyyy-MM-ddTHH:mm:ss",
                  dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss",
                  showClearButton: true,
                }}
              >
                <Label text={"Date"} />
                <RequiredRule
                  message={"* Training Date & Time을 입력해주세요."}
                />
                {/* <DateBox
                  type="datetime"
                  displayFormat={"yyyy-MM-ddTHH:mm:ss"}
                  dateSerializationFormat={"yyyy-MM-ddTHH:mm:ss"}
                  showClearButton={true}
                /> */}
              </SimpleItem>
              <SimpleItem
                dataField={"loc"}
                editorType="dxTextBox"
                editorOptions={{
                  showClearButton: true,
                }}
              >
                <Label text={"Location"} />
                <RequiredRule message={"* Location을 입력해주세요."} />
                {/* <TextBox /> */}
              </SimpleItem>
              <SimpleItem dataField={"trainer"}>
                <Label text="Trainer" />
                <SelectBox
                  ref={trainerRef}
                  dataSource={employeeDataSource}
                  valueExpr="employeeNo"
                  grouped={true}
                  // displayExpr="name"
                  displayExpr={displayExprEmployee}
                  itemRender={itemRender}
                  defaultValue={userInfo.employeeNo}
                  // disabled={true}
                  readOnly={true}
                />
              </SimpleItem>
              {/* <SimpleItem colSpan={3} dataField="trainee">
                <Label text={"Trainee"} />
                <DropDownBox
                  ref={traineeRef}
                  value={traineeValue}
                  valueExpr="employeeNo"
                  // valueExpr="id"
                  // displayExpr={"name"}
                  displayExpr={displayExprTreeViewEmployee}
                  showClearButton={true}
                  dataSource={employeeDataSource}
                  onValueChanged={onValueChangedTrainee}
                  contentRender={contentRenderTrainee}
                ></DropDownBox>
              </SimpleItem> */}
              <SimpleItem
                dataField={"trainee"}
                colSpan={2}
                editorType={"dxTagBox"}
                editorOptions={{
                  dataSource: employeeDataSource,
                  valueExpr: "employeeNo",
                  displayExpr: displayExprEmployee,
                  grouped: true,
                  // displayExpr="name"
                  itemRender: itemRender,
                  showSelectionControls: true,
                  applyValueMode: "useButtons",
                  searchEnabled: true,
                  showClearButton: true,
                  // onItemClick: onItemClick,
                  // groupRender: groupRender,
                }}
              >
                <Label text="Trainee" />
                <RequiredRule message={"* 학습자들을 선택해주세요."} />
              </SimpleItem>
              {/* <SimpleItem dataField="trainee" colSpan={3}>
                <Label text="Trainee" />
                <TagBox
                  ref={traineeRef}
                  dataSource={employeeDataSource}
                  valueExpr={"employeeNo"}
                  displayExpr={displayExprEmployee}
                  grouped={true}
                  // displayExpr="name"
                  itemRender={itemRender}
                  showSelectionControls={true}
                  applyValueMode={"useButtons"}
                  searchEnabled={true}
                  showClearButton={true}
                  onItemClick={onItemClick}
                  groupRender={groupRender}
                />
              </SimpleItem> */}
            </Form>
          </Editing>
          <Column
            dataField="type"
            caption="Training Type"
            dataType="string"
            width={140}
            alignment="center"
            setCellValue={setCellValue}
          >
            <Lookup
              dataSource={TYPE_INTERNAL}
              displayExpr="name"
              valueExpr={"id"}
            />
          </Column>
          <Column
            dataField="cat"
            caption="Category"
            dataType="string"
            width={110}
            alignment="center"
          >
            <Lookup dataSource={CAT} displayExpr="name" valueExpr={"id"} />
          </Column>
          <Column
            dataField="title"
            caption="Training Title"
            dataType="string"
            width={400}
          ></Column>
          <Column
            dataField="date"
            catpion="Training Date &amp; Time"
            dataType="date"
            // dataType={"datetime"}
            format={"yyyy-MM-ddTHH:mm:ss"}
            editorOptions={{
              dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss",
            }}
            width={170}
            alignment="center"
            filterOperations={["=", "between"]}
            calculateFilterExpression={calculateFilterExpression}
          ></Column>
          <Column
            dataField="time"
            caption="Duration"
            dataType="number"
            width={110}
            cellRender={cellRenderTime}
          />
          <Column
            dataField="loc"
            caption="Location"
            dataType="string"
            width={150}
          />
          {/* <Column
            dataField="trainer"
            caption="Trainer"
            dataType="string"
            cellRender={cellRenderTrainer}
            width={160}
          /> */}
          <Column
            dataField="trainerName"
            caption="Trainer"
            dataType="string"
            // cellRender={cellRenderTrainer}
            width={160}
            alignment="center"
          />
          {/* <Column
            dataField={"trainerSig"}
            caption={""}
            width={80}
            alignment={"center"}
            cellRender={cellRenderTrainerSig}
          /> */}
          <Column
            dataField="trainee"
            caption="Trainee"
            dataType="string"
            cellRender={cellRenderTrainee}
            visible={false}
          />
          <Column
            dataField="traineeName"
            caption="Trainee"
            dataType="string"
            allowHeaderFiltering={false}
          />
          {/* <Column
            dataField={"traineeSig"}
            caption={""}
            width={80}
            alignment={"center"}
            cellRender={cellRenderTraineeSig}
          /> */}
          <Column type={"buttons"} width={150}>
            <Button name={"edit"} disabled={editNDeleteDisabled} />
            <Button name="delete" disabled={editNDeleteDisabled} />
            <Button
              icon="check"
              visible={true}
              hint={"Signature"}
              disabled={checkDisabled}
              onClick={onClick}
              render={(data) => {
                const { trainerSig, traineeSig } = data.data;

                return (
                  <TrainingAttendanceList
                    trainerSig={trainerSig}
                    traineeSig={traineeSig}
                  />
                );
              }}
            ></Button>
          </Column>
          <Toolbar>
            {userInfo.jd != "RV" && (
              <Item location={"before"}>
                <Button2
                  icon={"filter"}
                  text={!myDiv ? "My Div." : "All Div."}
                  width="120"
                  onClick={onClickMyDiv}
                  type="success"
                  stylingMode="contained"
                />
              </Item>
            )}
            <Item location={"before"} name="groupPanel" />
            {userInfo.jd != "RV" && (
              <Item location={"after"} name="addRowButton" />
            )}
            <Item>
              <Button2 icon={"refresh"} onClick={onClickRefresh} />
            </Item>
            <Item>
              <Button2
                icon={"filter"}
                text={!filterNoSig ? "No Sig." : "All"}
                width="120"
                onClick={onClickFilterNoSig}
                type="default"
                stylingMode="contained"
              />
            </Item>
            <Item name={"searchPanel"} />
          </Toolbar>
        </DataGrid>
      )}
      <Popup
        id="signaturePopup"
        visible={signaturePopupVisible}
        onHiding={onHiding}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        // title="Training Attending List"
        // titleRender={titleRender}
        width={500}
        height={"auto"}
      >
        <ToolbarItem text="TRINING ATTENDING LIST" location="before" />
        <ToolbarItem
          widget={"dxButton"}
          location="after"
          options={{ icon: "exportpdf", text: "", onClick: exportPDF }}
          disabled={tpData.trainerSig ? false : true}
        />
        <ToolbarItem
          widget={"dxButton"}
          toolbar="bottom"
          location={"center"}
          // options={{
          //   text: "Trainer Sig.",
          //   stylingMode: "contained",
          //   type: "success",
          //   width: 450,
          // }}
          render={(data) => {
            return (
              <SignatureItem
                gridRef={tralGridRef}
                tpId={tpData.tpId}
                isTrainer={true}
                sig={tpData.trainerSig}
                sigEmployeeNo={tpData.trainer}
                noSig={noSig}
                setTrainingAttendanceListSignaturePopupVisible={
                  setSignaturePopupVisible
                }
              />
            );
          }}
        />
        {tpData && (
          <div className="form" id="training-container">
            <div className="dx-fieldset">
              <div className="dx-field">
                <div className="dx-field-label">Training Program</div>
                <div className="dx-field-value-static">{tpData.title}</div>
              </div>
              <div className="dx-field">
                <div className="dx-field-label">Training Date &amp; Time</div>
                <div className="dx-field-value-static">
                  {tpData.date} ({tpData.time}h)
                </div>
              </div>
              <div className="dx-field">
                <div className="dx-field-label">Trainer</div>
                <div className="dx-field-value-static">
                  {tpData.trainerName}
                </div>
              </div>
              <div className="dx-field">
                <div className="dx-field-label">Location</div>
                <div className="dx-field-value-static">{tpData.loc}</div>
              </div>
            </div>
          </div>
        )}

        <DataGrid
          ref={signatureTraineeGridRef}
          keyExpr={"no"}
          dataSource={signatureTraineeDataSource}
          rowAlternationEnabled={true}
          showBorders={true}
          showColumnLines={true}
          // focusedRowEnabled={true}
          allowColumnResizing={true}
          // columnAutoWidth={true}
          width={450}
          height={250}
        >
          <LoadPanel enabled={true} />
          {/* <FilterRow visible={true} /> */}
          <HeaderFilter visible={true} />
          <Scrolling mode={"virtual"} showScrollbar="always" />

          <Column
            dataField={"no"}
            caption="No"
            dataType="number"
            width={55}
            alignment="center"
            allowHeaderFiltering={false}
          />
          <Column
            dataField={"div"}
            caption="Dept."
            dataType={"string"}
            width={100}
            alignment="center"
          />
          <Column
            dataField={"trainee"}
            catpion="Trainee Name"
            dataType="string"
            cellRender={cellRenderTraineeOnSignature}
            width={150}
            alignment="center"
            visible={false}
          />
          <Column
            dataField={"traineeName"}
            catpion="Trainee Name"
            dataType="string"
            // cellRender={cellRenderTraineeOnSignature}
            width={150}
            alignment="center"
          />
          <Column
            dataField={"sig"}
            caption="Sig."
            cellRender={cellRenderTraineeSig}
            alignment="center"
          />
        </DataGrid>
      </Popup>
    </React.Fragment>
  );
}
